import React from 'react'
import { observer } from 'mobx-react-lite'

import Card from '@mui/material/Card'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { useGlobalCopyStore, TabContentContainer, useFinstrongStore, Loader } from '../../../common'
import { EmptyState } from '../../../common/components/EmptyState'
import IncomeTabContent from './IncomeTabContent'
import DebtPaymentTabContent from './DebtPaymentTabContent'
import DoubleBarChart from '../shared/DoubleBarChart'
import LineGraph from '../shared/LineGraph'

const HaveManagebleDebtComponent: React.FC = () => {
  const { isIncomeInitialized, loadDebtSpend, loadIncome, monthlySummaries } = useFinstrongStore()

  const [tabValue, setTabValue] = React.useState(0)
  const { finstrong: copy } = useGlobalCopyStore()

  React.useEffect(() => {
    if (!isIncomeInitialized) {
      loadDebtSpend().finally()
      loadIncome().finally()
    }
  }, [isIncomeInitialized])

  if (!isIncomeInitialized) return <Loader />

  const hasBarChartData = monthlySummaries.some(
    (eachItem) => eachItem.debt_spend !== 0 || eachItem.income !== 0,
  )

  return (
    <>
      <Card>
        <Tabs
          aria-label={copy.key_indicators_save.drawer_title}
          centered={true}
          onChange={(_, val) => setTabValue(val)}
          selectionFollowsFocus={true}
          sx={{ mb: 0 }}
          value={tabValue}
          variant="fullWidth"
        >
          <Tab
            aria-controls="income-details-tabpanel-0"
            id="income-details-tab-0"
            label={copy.key_indicators_borrow.have_manageable_debt_drawer.income}
            sx={{ minHeight: 44 }}
          />
          <Tab
            aria-controls="debt-payment-details-tabpanel-1"
            id="debt-payment-details-tab-1"
            label={copy.key_indicators_borrow.have_manageable_debt_drawer.debt_payment}
            sx={{ minHeight: 44 }}
          />
        </Tabs>

        <TabContentContainer
          aria-labelledby="income-details-tab-0"
          index={0}
          name="income-details"
          value={tabValue}
        >
          <IncomeTabContent />
        </TabContentContainer>

        <TabContentContainer
          aria-labelledby="debt-payment-details-tab-1"
          index={1}
          name="debt-payment-details"
          value={tabValue}
        >
          <DebtPaymentTabContent />
        </TabContentContainer>
      </Card>

      {hasBarChartData ? (
        <>
          <DoubleBarChart
            chartFor="debt_payment_vs_income"
            data={monthlySummaries}
            legendLabelComparison={
              copy.key_indicators_borrow.have_manageable_debt_drawer.debt_payment
            }
            legendLabelMain={copy.key_indicators_borrow.have_manageable_debt_drawer.income}
            title={copy.key_indicators_borrow.have_manageable_debt_drawer.debt_payment}
          />
        </>
      ) : (
        <EmptyState
          header={
            copy.key_indicators_borrow.have_manageable_debt_drawer
              .have_manageable_debt_double_bar_chart_empty_state_header
          }
          icon="multiline_chart"
          subText={
            copy.key_indicators_borrow.have_manageable_debt_drawer
              .have_manageable_debt_double_bar_chart_empty_state_description
          }
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 1,
            p: 24,
            pb: 48,
            '.empty-state-subtext': {
              fontSize: 15,
              lineHeight: '24px',
              mt: 8,
            },
          }}
        />
      )}
      <LineGraph chartFor="debtOverTime" />
    </>
  )
}

export default observer(HaveManagebleDebtComponent)
